class Thenable {

    constructor(value) {
        this.value = value
    }

    then(resolve) {
        // Immediately resolve the value
        return Thenable.resolve(resolve(this.value))
    }

    // eslint-disable-next-line class-methods-use-this
    catch() {
        // An immediate value will never reject
        return Thenable.EMPTY
    }
}

Thenable.EMPTY = new Thenable()

Thenable.resolve = (value) => {
    if (value && typeof value.then === 'function') {
        // Value is already a Promise or a generic thenable
        return value
    }
    // Return a thenable with immediate value resolver
    return new Thenable(value)
}

export default Thenable
